const reportError = require('airship/modules/error-reporting')

const ractiveModal = require('airship/widgets/ractive-modal')

const template = require('./form.ract')

module.exports = setupSuspensions

function setupSuspensions(el) {
  const successUrl = el.dataset.successUrl
  const data = {}
  let modal

  if (successUrl) {
    data['successUrl'] = `${window.location.origin}${successUrl}`
  } else {
    reportError(new Error("successUrl wasn't defined"), __filename)
  }

  modal = ractiveModal(template, {data})

  el.addEventListener('click', ev => {
    ev.preventDefault()
    ev.stopPropagation()

    modal.open()
  })

  return modal
}
